<script lang="ts">import { Checkbox } from "@infinitro/checkbox";
import { t, Verbiage } from "@infinitro/content";
import { stateTermsConfirmed } from "../state";
let _element;
const onCheck = (event) => stateTermsConfirmed.set(event.detail.checked);
</script>

<span class="section">
	<span class="terms">
		<span class="input-container">
			<Checkbox
				id="confirmAgeCheckbox"
				label={$t(Verbiage.confirm_age_terms)}
				checked={$stateTermsConfirmed}
				on:change={onCheck}
			/>
		</span>
	</span>
</span>

<style>
	.section {
		display: flex;
		flex-direction: column;
		align-items: baseline;
		padding-bottom: 0.5rem;
}
	.input-container {
		display: flex;
		align-items: center;
		padding: 0.5rem;
}
	/*
	input {
		@apply w-5 h-5 mr-2 rounded-lg;
	}
	*/
	@media (min-width: 640px) {
		input {
				height: 1.25rem;
				width: 1.25rem;
		}
	}
	.terms {
		display: flex;
		flex-direction: row;
		align-items: center;
		vertical-align: middle;
		font-size: 0.7rem;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
	:global(.custom-checkbox-text) {
		font-size: 12px !important;
	}
	:global(.custom-checkbox-text *) {
		font-size: 12px !important;
	}
</style>
